export const entradaTypeList = [
    {value: 'NAO_POSSUI', label: 'Não Possui'},
    {value: 'INCLUSA_PARCELAS', label: 'Inclusa nas parcelas'},
    {value: 'NAO_INCLUSA_PARCELAS', label: 'Não inclusa nas parcelas'},
]